<template>
  <div id="c3-schedule-l" class="schedule">
    <ReportDraftWatermark v-if="report.is_draft" />
    <h2 class="formTitle">Schedule L: Loans</h2>
    <div class="report-section">
      <h3 class="line-item-title">
        1. Monetary loan received
      </h3>
      <div v-if="arrayHasItems(report.user_data.loans)">
        <v-simple-table dense>
          <thead>
          <tr>
            <th class="dateColumn">
              Date loaned
            </th>
            <th>
              Lender/Occupation & Employment
            </th>
            <th class="amountColumn">
              Amount of loan
            </th>
            <th class="amountColumn">
              Annual interest rate
            </th>
            <th>
              Payment
            </th>
            <th>Endorser</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in report.user_data.loans" :key="index">
            <td style="vertical-align: text-top;">
              {{ formatDate(item.date) }}
            </td>
            <td style="vertical-align: text-top;">
              <ContactInfo :contacts="contacts" :cont-id="item.contact_key"/>
              <div v-if="getContributionTotal(item) > 100">
                <RecipientInfo :contacts="contacts" :cont-id="item.contact_key"/>
              </div>
            </td>
            <td class="amountColumn" style="vertical-align: text-top;">
              {{ electionFilter(item.election) }}
              <br/>
              {{ formatMoney(item.amount) }}
            </td>
            <td class="amountColumn" style="vertical-align: text-top;">
              <div>
                <strong>Interest rate:</strong><br/>
                {{ item.interest_rate }}<span v-if="item.interest_rate">%</span>
              </div>
              <div>
                <strong>Aggregate:</strong><br/>
                {{ formatMoney(getAggregateTotal(contacts, item.contact_key, item.election)) }}
              </div>
            </td>
            <td style="vertical-align: text-top;">
              <div>
                <strong>Due date:</strong><br/>
                {{ formatDate(item.due_date) }}
              </div>
              <div>
                <strong>Payment Schedule:</strong><br/>
                {{ item.payment_schedule }}
              </div>
            </td>
            <td style="vertical-align: text-top;">
             <EndorserInfo v-for="(g, index) in item.endorser" :contacts="contacts" :cont-id="g.contact_key" :key="`endorser-${index}`"/>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </div>
      <div v-else class="noReport">
        No monetary loans reported this period
      </div>
      <v-divider></v-divider>
    </div>
  </div>
</template>
<script>
import filters from "../filters";
import utils from "./report-utils";
import ContactInfo from "./ContactInfo";
import EndorserInfo from "./EndorserInfo";
import RecipientInfo from "./RecipientInfo";
import ReportDraftWatermark from "@/components/ReportDraftWatermark";

export default {
  name: "C3ScheduleL",
  components: {EndorserInfo, ContactInfo, RecipientInfo, ReportDraftWatermark},
  props: {
    report: Object
  },
  data() {
    return {
      contacts: [],
      showOccupation: false
    }
  },
  methods: {
    ...filters.filters, ...utils,
    getContributionTotal(item) {
      return ((item.in_kind ? item.in_kind : 0) + (item.amount ? item.amount : 0));
    }
  },
  created() {
    this.contacts = this.report.user_data.contacts;
    this.sortByDate(this.report.user_data.loans);
  }


}
</script>
